import React, { useState, useEffect } from "react";
import { getContentByType } from "../../../utils/API/getStaticPages";
import { useDispatch } from "react-redux";
import { Skeleton } from "antd";
const PrivacyBody = () => {
  const dispatch = useDispatch();
  const [privacyContent, setPrivacyContent] = useState(null);
  useEffect(() => {
    const fetchPrivacyContent = async () => {
      try {
        const response = await getContentByType("privacyPolicy", dispatch);

        if (response && response.content) {
          setPrivacyContent(response.content.pageContent);
        } else {
          console.error("Invalid response format:", response);
        }
      } catch (error) {
        console.error("Error fetching privacy content:", error);
      }
    };

    fetchPrivacyContent();
  }, []);

  if (!privacyContent) {
    return (
      <div className="flex flex-col gap-y-4 m-4 px-24">
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
      </div>
    );
  }
  return (
    <>
      <div className="h-full  ">
        <div className="bg-blue-100 pt-8">
          <div
            className="flex justify-center h-[26rem] items-center pt-12 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('/images/contactusheader.png')",
              backgroundSize: "100%"
            }}
          >
            <div className="py-20 bg-opacity-70">
              <div className="text-[120px] flex font-normal justify-center">
                PRIVACY <span className="text-blue-800">POLICY</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between  bg-white mb-8 py-4 px-2 rounded-md">
        <div
          className="px-32 pt-8"
          dangerouslySetInnerHTML={{ __html: privacyContent }}
        />
      </div>
    </>
  );
};

export default PrivacyBody;
